import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesLoginMain } from './modules/ui/Main';

const LoginPage = (
  <SuspensePage>
    <PagesLoginMain />
  </SuspensePage>
);

export default LoginPage;
